import * as stateManagement from '#packages/stateManagement';

export const { showUserActionNotification } =
  stateManagement.notifications.actions;
